export default "__VITE_ASSET__9d09d4e5__"